<script setup lang='ts'>
// TODO: このコンポーネントを無くして、直接vue-chart.jsを使うようにしてツリーシェイキングさせる
// https://vue-chartjs.org/migration-guides/#tree-shaking
import 'chart.js/auto'
import { Bar } from 'vue-chartjs'
import type { ChartData, ChartOptions } from 'chart.js'
import { computed } from 'vue'
interface Props {
  options: ChartOptions<'bar'>
  chartData: ChartData<'bar'>
}

const props = defineProps<Props>()

const modifiedOptions = computed(() => {
  return Object.assign({ indexAxis: 'y' }, props.options)
})

</script>

<template>
  <Bar :chart-data="chartData" :chart-options="modifiedOptions" />
</template>
